(function () {
  'use strict';

  var selector = '[data-ginyhome-related-products]';
  var initializedAttribute = 'data-ginyhome-recommendations-initialized';
  var recommendationLimit = 4;

  function getRecommendationUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.product_recommendations_url) || '/recommendations/products';
  }

  function requestRecommendations(container, intent) {
    var section = container.closest('[data-section-type="related-products"]');
    var url = new URL(getRecommendationUrl(), window.location.origin);
    var sectionId = section && section.getAttribute('data-section-id');
    var productId = container.getAttribute('data-product-id');
    var configuredLimit = parseInt(container.getAttribute('data-limit'), 10);
    var limit = Number.isFinite(configuredLimit) ? Math.min(configuredLimit, recommendationLimit) : recommendationLimit;

    url.searchParams.set('section_id', sectionId || '');
    url.searchParams.set('limit', String(limit));
    url.searchParams.set('product_id', productId || '');
    url.searchParams.set('intent', intent);

    return fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Recommendation request failed: ' + response.status);
      }

      return response.text();
    }).then(function (markup) {
      var fragment = document.createElement('div');
      fragment.innerHTML = markup;
      return fragment.querySelector(selector);
    });
  }

  function hasValidRecommendations(container) {
    return Boolean(container && container.querySelector('[data-product-block]'));
  }

  function mountRecommendations(container, responseContainer) {
    container.innerHTML = responseContainer.innerHTML;
  }

  function loadRecommendations(container) {
    if (!container || container.hasAttribute(initializedAttribute)) {
      return;
    }

    container.setAttribute(initializedAttribute, 'true');

    requestRecommendations(container, 'complementary')
      .then(function (complementary) {
        if (hasValidRecommendations(complementary)) {
          mountRecommendations(container, complementary);
          return null;
        }

        return requestRecommendations(container, 'related');
      })
      .then(function (related) {
        if (hasValidRecommendations(related)) {
          mountRecommendations(container, related);
        }
      })
      .catch(function () {
        /* Keep the recommendation area empty when both native requests fail. */
      });
  }

  function initRecommendations() {
    document.querySelectorAll(selector).forEach(loadRecommendations);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecommendations);
  } else {
    initRecommendations();
  }

  document.addEventListener('shopify:section:load', initRecommendations);
}());
